import React from 'react';
type CtaButtonProps = {
  children: React.ReactNode;
  size?: 'lg' | 'xl';
  fullWidth?: boolean;
  href?: string;
};
declare global {
  interface Window {
    fbq?: any;
  }
}
export function CtaButton({
  children,
  size = 'lg',
  fullWidth = false,
  href = '#oferta'
}: CtaButtonProps) {
  const sizing = size === 'xl' ? 'px-10 py-5 text-base md:text-lg' : 'px-8 py-4 text-sm md:text-base';
  const handleClick = () => {
    if (href === 'https://metodofutbol.impultienda.ar/checkout' && window.fbq) {
      window.fbq('track', 'InitiateCheckout', {
        value: 19.99,
        currency: 'ARS'
      });
    }
  };
  return <a href={href} onClick={handleClick} style={{
    textAlign: 'center',
    justifyContent: 'center',
    display: 'inline-flex',
    alignItems: 'center'
  }} className={`rounded-full bg-[#15803d] font-extrabold uppercase tracking-wide text-white shadow-cta transition-[background-color,transform] duration-150 ease-out hover:bg-[#166534] hover:-translate-y-0.5 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-brand-green ${sizing} ${fullWidth ? 'w-full' : ''}`} data-id="element-228" data-mp="1d6av2lv9m599">
      {children}
    </a>;
}